// Les réponses de « Quand ça coince » (page Aide de Radar), dans l'ordre de la
// page. L'identifiant sert aussi d'adresse (`#/aide?q=mails`) : un lien cité
// dans une réponse au formulaire ouvre la bonne. Chacune a sa question
// (`aideR.q.<id>`) et sa réponse (`aideR.r.<id>`) dans i18n.ts ; la page les
// lit par une clé construite, que TypeScript ne vérifie pas : aide.test.ts le fait.

export const QUESTIONS_AIDE = ['score', 'reconnait', 'employeur', 'mails', 'rythme', 'pause', 'supprimer'] as const
export type QuestionAide = (typeof QUESTIONS_AIDE)[number]
